import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";

export const ActionButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.error.main,
  borderRadius: "8px",
  height: "40px",
  width: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: "8px",
  transition: "background 0.2s",
  "&:hover": {
    backgroundColor: "rgba(211, 47, 47, 0.28)",
    color: theme.palette.error.dark,
  },
}));